export default __webpack_public_path__ + "static/media/GitIcon.eb9216bc.svg";